import { cn } from "@mozioinc/ui";
import SpinnerSvg from "./assets/spinner.svg?react";
import type { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

export type ButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  color: "primary" | "secondary";
  loading?: boolean;
};

export const Button = (props: ButtonProps) => {
  const { color, className, children, loading, disabled, ...others } = props;
  const _disabled = loading || disabled;

  return (
    <button
      className={cn(
        "relative rounded px-3 py-2 duration-200 hover:brightness-95",
        {
          "bg-primary text-primary-contrast": color === "primary",
          "bg-secondary text-secondary-contrast": color === "secondary",
          "opacity-60": _disabled,
          "pr-9": loading,
        },
        className,
      )}
      disabled={_disabled}
      type="button"
      {...others}
    >
      {children}

      {loading && (
        <SpinnerSvg className="absolute right-3 top-1/2 inline-block h-4 w-4 -translate-y-1/2  stroke-white" />
      )}
    </button>
  );
};
